import { type FC, lazy, Suspense } from 'react';
import { useClientState } from 'dibs-react-hooks/exports/useClientState';

const ZoomModal = lazy(() => import(/* webpackChunkName: "NftPdpZoomModal" */ './NftPdpZoomModal'));

type Props = Parameters<typeof ZoomModal>[0];

export const NftPdpZoomModalLazy: FC<Props> = props => {
    const isClient = useClientState();
    return isClient ? (
        <Suspense fallback="">
            <ZoomModal {...props} />
        </Suspense>
    ) : null;
};
